import apiClient from '../api/apiClient';
import {ResponseDto} from "./ResponseDto";
import {CoordinatorData, CoordinatorDetailData} from "../interface/CoordinatorData";

export interface ApplyCoordiDto {
    category: string;
    nationality: string;
    preferredAreaMajor: string;
    preferredAreaMinor: string;
    hasCareer: boolean;
    careerYear: number | null;  // null 허용
    careerMonth: number | null;  // null 허용
    introduction: string;
    imagePath: string;  // profileImageType → imagePath
    certificates: Array<{ certificateName: string; certificateIssuer: string; issueDate: string }>;
}
export const applyCoordi = (data: FormData) =>
    apiClient.post<ResponseDto<void>>('/api/front/coordi/applyCoordinator', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
// 코디네이터 신청 상세 조회
export const getCoordinatorDetail = () =>
    apiClient.get<ResponseDto<CoordinatorDetailData>>('/api/front/coordi/detail');


// 코디네이터 상태 체크
export const checkCoordinatorStatus = () =>
    apiClient.get<ResponseDto<string>>('/api/front/coordi/status');

// 코디네이터 정보 수정 (보완 요청 완료)
export const updateCoordinator = (data: FormData) =>
    apiClient.put<ResponseDto<void>>('/api/front/coordi/update', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
//좋아요
export const toggleFavorite = (coordinatorCode: string) =>
    apiClient.post<boolean>(`/api/front/coordi/toggleFavorite/${coordinatorCode}`);


export const getFavoriteCoordinatorList = () =>
    apiClient.get<ResponseDto<CoordinatorData[]>>(`/api/front/coordi/favorite/list`);